// extracted by mini-css-extract-plugin
module.exports = {"container":"contact_container__2wxbs","heading":"contact_heading__1FL44","form":"contact_form__MWKUf","message":"contact_message__1Dqpf"};